import React from "react";
import * as loadingData from "./loading.json";

import Lottie from "react-lottie";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function Loading({ appendToBody, width = 150, height = 150 }) {
  return (
    // <FadeIn>
    <div
      style={{
        position: appendToBody ? "absolute" : "fixed",
        top: 0,
        left: 0,
        zIndex: 4000,
        width: "100%",
        height: "100%",
        background: "#6c6c7033",
        // opacity: 0.5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height}
        width={width}
        isPaused={false}
        isStopped={false}
        isClickToPauseDisabled={true}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          zIndex: 4100,
          transform: "translate(-50%,-50%)",
        }}
      />
    </div>
    // </FadeIn>
  );
}

export default Loading;
